// extracted by mini-css-extract-plugin
export default {"splitRow":"SplitRow-module__splitRow___G035e"};